module.exports = __webpack_public_path__ + "resources/img/ico_error.de2a0b207264f73b5889a550c20a299a.png";